define('OutSystems/ClientRuntime/modules/PersistentKeyValue/PersistentKeyValueTableInfo',["require", "exports", "../../modules/Database/AutoNumber", "../../modules/Database/DBDataType"], function (require, exports, AutoNumber_1, DBDataType_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PERSISTENT_TABLE_INFO = {
        tableName: "OSSYS_PERSISTENTKEYVALUE",
        idIsAutoNumber: AutoNumber_1.default.No,
        attributes: [
            { name: "Key", columnName: "KEY", type: DBDataType_1.default.TEXT, isPrimaryKey: true },
            { name: "Value", columnName: "VALUE", type: DBDataType_1.default.TEXT },
        ],
    };
    exports.default = PERSISTENT_TABLE_INFO;
});
//# sourceMappingURL=PersistentKeyValueTableInfo.js.map;
